import React from 'react';
import { Size } from 're-resizable';
import { useTranslation } from 'react-i18next';

import { Header, Wrapper } from 'widget/components';
import { useIsPrimaryDark } from 'widget/hooks';
import { useResize } from '../hooks';

import Closer from './closer/closer';
import Restore from './restore/restore';

interface ChatHead {
  size: Size;
  updateSize: (value: Size) => void;
}

const ChatHead = ({ size, updateSize }: ChatHead) => {
  const { defaultSize } = useResize();
  const { t } = useTranslation();
  const isPrimaryDark = useIsPrimaryDark();

  const isRestoreVisible =
    defaultSize.height != size.height || defaultSize.width != size.width;

  return (
    <div className="whatcrm-widget-chat__head">
      <Wrapper className="whatcrm-widget-chat__control-buttons">
        <Closer />
        {isRestoreVisible && <Restore updateSize={updateSize} />}
      </Wrapper>

      <Header.H3 color={isPrimaryDark ? 'white' : 'dark'}>
        {t`Ask your question`}
      </Header.H3>
    </div>
  );
};

export default ChatHead;
